import React from "react";
import { GetAdminListing } from "../../../redux/features/AdminService";
import UserManagementWrapper from "../../Common/UserManagementWrapper";

const ArchivedAdminUsers = ({ filteredData }) => { // NOSONAR
  return (
    <UserManagementWrapper
      fetchFunction={GetAdminListing}
      fetchArgs={{
        search: "",
        role: 1,
        status: "0",
      }}
      selector={(state) => state.admin.getAdminListing}
      detailRoute="/admin-users"
      filteredData={filteredData}
    />
  );
};

export default ArchivedAdminUsers;